<div class="checklist-progress-bar">
	<div class="percentage">{{ percentage }}%</div>
	<div class="track-bar">
		<div class="progress-bar" [ngStyle]="{ width: percentage + '%' }"></div>
	</div>
</div>
